export class ChatbotConsumption {
  constructor(
    public name: string,
    public consumption: number,
    public messages: number,
  ) {}
}